<template>
  <img :src="srcComputed" :width="width" :height="height" :alt="alt" />
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { getFullPathForPublicAssets } from '@/utils/url';

const props = defineProps({
  src: { type: String, required: true },
  width: { type: String, required: false },
  height: { type: String, required: false },
  alt: { type: String, required: true },
});

const srcComputed = computed(() => (props.src.startsWith('/') ? getFullPathForPublicAssets(props.src) : props.src));
</script>
<style scoped lang="scss">
img {
  max-width: 100%;
  max-height: 100%;
}
</style>
